<ds-tile class="program-tile">
  <div class="tile-heading" tile-heading>
    <div class="heading-text wrap">
      <div class="flex items-center">
        <img src="/assets/images/afi-autopay.svg" alt="auto pay image" data-cy="autoPayImage" />
        <span
          class="heading-section"
          dsContent
          [contentPath]="
            isAutopayCardEnhancementsEnabled
              ? 'overview.multipleAutopayHeaderB'
              : 'overview.multipleAutopayHeaderA'
          "
          data-cy="multipleAutopayHeader"
        ></span>
      </div>
      @if (isAutopayCardEnhancementsEnabled) {
        <div>
          <p
            class="margin-bottom-0 margin-top-12"
            dsContent
            [contentPath]="'overview.multipleAutomaticPaymentInfo'"
            data-cy="multipleAutomaticPaymentInfo"
          ></p>
          <p
            class="heading-sub"
            dsContent
            [contentPath]="'overview.multipleAutomaticPaymentInfoSub'"
            data-cy="multipleAutomaticPaymentInfoSub"
          ></p>
        </div>
      }
    </div>
  </div>
  <div class="tile-content" tile-content>
    <div class="pad-bottom-12">
      <ul class="complete-list">
        <li
          dsContent
          [contentPath]="'overview.multipleLateChoose'"
          data-cy="multipleLateChoose"
        ></li>
        <li dsContent [contentPath]="'overview.multipleLateGet'" data-cy="multipleLateGet"></li>
        <li
          dsContent
          [contentPath]="'overview.multipleCancelAnytime'"
          data-cy="multipleCancelAnytime"
        ></li>
      </ul>
    </div>
  </div>
  <div tile-cta class="tile-cta">
    <button
      data-cy="autopayOverviewCardButton"
      ds-button
      authCheck
      [permissionName]="'makeautopayrule_walkthrough'"
      [checkAction]="'disable'"
      class="-outline-primary"
      (click)="ctaClickEvent.emit()"
      [attr.aria-label]="mutipleAutopaySetupBtnContent"
      [dsAnalyticsClick]="buttonAnalyticData?.link"
    >
      {{ mutipleAutopaySetupBtnContent }}
    </button>
  </div>
</ds-tile>
